class GestionService {
  constructor() {}
  resources = () => ({
    tiposCampamento: {
      uri: `/v1/tiposcampamento`,
      method: ['get']
    },
    sectores: {
      uri: `/v1/sectores`,
      method: ['get']
    },
    aldeas: {
      uri: `/v1/unidadcampamento/aldeas`,
      method: ['get']
    },
    carpas: {
      uri: `/v1/unidadcampamento/carpas-por-aldeas`,
      method: ['get']
    },
    unidadcampamento: {
      uri: `/v1/unidadcampamento`,
      method: ['get']
    },
    sectoresPadres: {
      uri: `/v1/sectorespadres`,
      method: ['get']
    },
    estado: {
      uri: `/v1/unidadcampamento/cambiarestado`,
      method: ['put']
    },
    sexo: {
      uri: `/v1/unidadcampamento/cambiarsexo`,
      method: ['put']
    }
  });
}

export default GestionService;
